export function lightenColor(color, percent) {
  const hex = color.replace('#', '');

  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  const lighten = value => {
    const amount = Math.round((255 - value) * (percent / 100));
    return Math.min(255, value + amount);
  };

  const newR = lighten(r);
  const newG = lighten(g);
  const newB = lighten(b);

  const toHex = value => value.toString(16).padStart(2, '0');

  return `#${toHex(newR)}${toHex(newG)}${toHex(newB)}`;
}
